import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {AppService} from '@irb/app.service';
import {PageService} from '@irb-common/services/page.service';
import {IrbDashboardService} from '@irb/irb-dashboard/irb-dashboard.service';
import {IRebalanceDetails} from '@irb/irb-dashboard/irb-dashboard.model';
import {faChevronRight, faCircle} from '@fortawesome/free-solid-svg-icons';
import {IApplyFilterOnLanding} from '@irb/app.model';
import {IrbRebalanceEvents} from '@irb/irb-common/events';
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';

@Component({ standalone: false,
  selector: 'irb-com-rebalancing',
  templateUrl: './com-rebalancing.component.html',
  styleUrls: ['./com-rebalancing.component.scss']
})
export class ComRebalancingComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  private _data: Array<IRebalanceDetails>;
  faChevronRight = faChevronRight;
  faCircle = faCircle;

  constructor(
    public as: AppService,
    public ps: PageService, 
    private dbs: IrbDashboardService, 
    private router: Router,
    private ats: AnalyticsService
  ) {}

  ngOnInit() {
    this.ps.getUserDetails().pipe(takeUntil(this.destroyed$)).subscribe((d) => {   
      if(d) {
        this.ps.deserializePageState(this.as.getFromSession("pageState"),["rebalResultsGridDiv"]);

        this.dbs.getRebalanceDetails().pipe(takeUntil(this.destroyed$)).subscribe((d) => {
          this.data = (d as Array<IRebalanceDetails>).slice(0,9);
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  showCreateRebalance() {
    const crConfig = { 
      fullscreen: true
    };
    
    this.ats.trackClickEvent("md_createrebal");
    this.as.fireEvent(IrbRebalanceEvents.SHOW_EDIT_CREATE_REBALANCE, crConfig);
  }

  showRebalanceResultSummary(rebalPkgId: number) {
  
    const state: IApplyFilterOnLanding = {
      isUpdatRequired: true,
      filterModel: { name: 'rebalPkgId', value:[rebalPkgId+""] , isUpdatRequired: true }
    } as IApplyFilterOnLanding;

    this.router.navigate(["/rebalancing/result-summary/", rebalPkgId]);
  }

  get data(): Array<IRebalanceDetails> {
    return this._data;
  }

  set data(d: Array<IRebalanceDetails>) {
    this._data = d;
  }
}
